var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import examIcon from '../../../assets/images/avatars/avatar-exam-schedule.svg';
import physicianIcon from '../../../assets/images/avatars/avatar-phys.svg';
import serviceIcon from '../../../assets/images/global/avatar-service.svg';
import consultationIcon from '../../../assets/images/global/consultation.svg';
import simpleAvatarIcon from '../../../assets/images/icons/avatar_user.svg';
import checkupIcon from '../../../assets/images/avatars/avatar-checkup.svg';
import ConfirmedSVG from '../../../assets/images/icons/Confirmed.svg';
import LostSVG from '../../../assets/images/icons/Lost.svg';
import CanceledSVG from '../../../assets/images/icons/Canceled.svg';
import checkSVG from '../../../assets/images/global/check-green.svg';
import RequestedSVG from '../../../assets/images/icons/Requested.svg';
import InExecutionSVG from '../../../assets/images/icons/In_execution.svg';
import { getStatusTextByIeStatus, getStatusTextByIeStatusListaEspera } from '../../../util/card-util';
import './card-appointments-title.css';
import CardAppointmentsTitleAPI from './card-appointments-title-api';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
const STATUS_ICON_MAP = (type) => {
    switch (type) {
        case '10':
            return checkSVG;
        case '15':
            return CanceledSVG;
        case '20':
            return LostSVG;
        case '25':
            return InExecutionSVG;
        case '30':
            return CanceledSVG;
        case '35':
            return ConfirmedSVG;
        case '40':
            return ConfirmedSVG;
        case 'P':
            return InExecutionSVG;
        case 'R':
            return RequestedSVG;
        case 'X':
            return CanceledSVG;
        default:
            return '';
    }
};
const APPOINTMENTS_ICON_MAP = (type) => {
    switch (type) {
        case 'C':
            return consultationIcon;
        case 'CH':
            return checkupIcon;
        case 'E':
            return examIcon;
        case 'Y':
        case 'Q':
            return physicianIcon;
        case 'R':
            return consultationIcon;
        case 'S':
            return serviceIcon;
        default:
            return '';
    }
};
let CardAppointmentsTitle = class CardAppointmentsTitle extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            showSubTitle: false
        };
    }
    static { this.propTypes = {
        dsFotoBase64: string,
        dsSubTitulo: string,
        dsTitulo: string,
        ieScheduleType: string,
        onClick: eventListener,
    }; }
    render() {
        const { showSubTitle } = this.state;
        const { ieStatus, ieStatusListaEspera, dsTitulo, dsSubTitulo, ieScheduleType, dsFotoBase64, dsTypeSchedule } = this.props;
        const titleAvatar = dsTitulo ?? '-';
        const subtitleAvatar = dsSubTitulo ?? dsTypeSchedule;
        let cardImage = simpleAvatarIcon;
        if (ieScheduleType) {
            cardImage = dsFotoBase64 ? dsFotoBase64 : APPOINTMENTS_ICON_MAP(ieScheduleType);
        }
        return (React.createElement(React.Fragment, null,
            showSubTitle && React.createElement("div", { className: "sub-title" }, dsTypeSchedule),
            React.createElement(Card, { width: 12, selectable: false, selectionType: SelectionType.NONE, uuid: generateUUID(), className: 'card-appointments-detail-title' },
                React.createElement("div", { className: "container-title" },
                    React.createElement("div", { className: "column-avatar avatar-title" },
                        React.createElement(Avatar, { image: cardImage, title: titleAvatar, size: Size.SMALL, subtitle: subtitleAvatar })),
                    React.createElement("div", { className: "column-status" },
                        React.createElement("div", { className: 'status' },
                            React.createElement(Text, { className: "column-status-text", value: ieStatusListaEspera ? getStatusTextByIeStatusListaEspera(ieStatusListaEspera) : getStatusTextByIeStatus(ieStatus) }),
                            React.createElement(Image, { src: STATUS_ICON_MAP(ieStatus), alt: '', className: 'icon-status-title' })))))));
    }
};
CardAppointmentsTitle = __decorate([
    AwesomeComponent({ api: CardAppointmentsTitleAPI, type: ComponentType.DATA_DISPLAY })
], CardAppointmentsTitle);
export default CardAppointmentsTitle;
//# sourceMappingURL=card-appointments-title.js.map